import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CustomerWizardResponse} from '../../../../../../domain/data/customer-wizard-response.data';
import {VehicleBrand} from '../../../../../../domain/core/vehicle-brand.model';
import {LegalEntity} from '../../../../../../domain/core/legal-entity.model';
import {WizardType} from '../../../wizard-type.enum';
import {Country} from '../../../../../../domain/core/country.model';
import {NgStyle} from '@angular/common';

@Component({
  selector: 'app-wizard-dig-sig-customer-data',
  imports: [
    NgStyle
  ],
  templateUrl: './wizard-dig-sig-customer-data.component.html',
})
export class WizardDigSigCustomerDataComponent {
  @Input() customerWizardResponse: CustomerWizardResponse;
  @Input() brand: VehicleBrand;
  @Input() legalEntity: LegalEntity;
  @Output() nextStep = new EventEmitter<void>();

  protected readonly WizardType = WizardType;
  protected readonly Country = Country;

  getVisibleContactLines(data: any): string[] {
    return [
      data.emailPersonal,
      data.emailOffice,
      data.phoneMobile,
      data.phoneHome,
      data.phoneOffice,
    ].filter(Boolean);
  }
}
